'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var lines = exports.lines = [{
  key: 48,
  text: '48小时警戒线',
  color: '#ff0',
  path: [[25, 118.7], [25, 122], [25, 126], [21, 126], [14, 119], [14, 114.5], [14, 109.5], [17, 109.5], [18.2, 109.5]]
}, {
  key: 24,
  text: '24小时警戒线',
  color: '#f00',
  path: [[25, 122], [21, 121], [17, 117], [17, 109.5]]
}];


//////////////////
// WEBPACK FOOTER
// ./js/util/typhoonArea.js
// module id = 18
// module chunks = 0